import { useTranslation } from "react-i18next";
import { AlertSpg, GridItem } from "@duosoftbg/nacid-components";
import { IconButton, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import React from "react";

const AccessRolesDialogList = ({ roles, isEdit, onRemove = (role) => {} }) => {
  const { t } = useTranslation();

  return (
    <>
      {roles && roles.length > 0 ? (
        roles.map((role) => (
          <GridItem key={role}>
            <Typography ml={3} component={"span"} fontSize={16}>
              {role}
            </Typography>
            {isEdit ? (
              <Typography component={"span"} fontSize={16}>
                <IconButton
                  title={t("l.btn.remove")}
                  color={"error"}
                  style={{ position: "relative" }}
                  onClick={(e) => onRemove(role)}
                >
                  <FontAwesomeIcon style={{ fontSize: 20 }} icon={faXmark} />
                </IconButton>
              </Typography>
            ) : null}
          </GridItem>
        ))
      ) : (
        <GridItem sm={12} md={12} lg={12}>
          <AlertSpg ml={3} severity="info">
            {t("m.empty.list")}
          </AlertSpg>
        </GridItem>
      )}
    </>
  );
};

export default AccessRolesDialogList;
